import React from 'react';
import { useLocation } from 'react-router-dom';
import LocalizedLink from '../../LocalizedLink';

export default function Sidebar() {
  const location = useLocation();
  const menuItems = [
    { name: 'Ostmine', path: '/ostmine' },
    { name: 'Tarne', path: '/tarne' },
    { name: 'Kasutustingimused', path: '/tingimused' },
    { name: 'Privaatsuspoliitika', path: '/privaatsuspoliitika' },
    {
      name: 'Auhinnaloosi kampaaniareeglid',
      path: '/auhinnaloosi-kampaaniareeglid',
    },
  ];

  return (
    <div className="w-full md:w-60 lg:w-80 p-4 lg:p-12 space-y-4 shrink-0">
      {menuItems.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <LocalizedLink
            key={item.name}
            to={item.path}
            className={`block text-xl transition-colors duration-100 ${
              isActive
                ? 'text-rgreen font-axi-bold'
                : 'text-black hover:font-axi-bold font-axi-book'
            }`}
          >
            {item.name}
          </LocalizedLink>
        );
      })}
    </div>
  );
}
